export const cifNr = ["301 151","<g fill-rule='nonzero' fill='none'><path fill='#002B7F' d='M.5.5h300v150H.5z'/><path fill='#FFC61E' d='M.5 69.25h300v12.5H.5z'/><path fill='#FFF' d='M75.5 131.75l-3.235-12.926L63 128.4l3.661-12.812-12.812 3.661 9.577-9.265L50.5 106.75l12.926-3.235-9.577-9.265 12.812 3.661L63 85.1l9.265 9.576L75.5 81.75l3.235 12.926L88 85.1l-3.661 12.812 12.812-3.661-9.577 9.265 12.926 3.234-12.926 3.235 9.577 9.265-12.812-3.661L88 128.4l-9.265-9.576z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-nr.js
// module id = null
// module chunks = 